// extracted by mini-css-extract-plugin
export default {"MyDevelopersUsers-layout":"MyDevelopersUsers-layout1irKbOcXAuFt","MyDevelopersUsers-page":"MyDevelopersUsers-pagep6q1dHxnKVVL"};